
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[article]",
      function () {
        return require("private-next-pages/articles/[article].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[article]"])
      });
    }
  